import { createContext, useContext, useState, useEffect } from 'react';

export const LANGS = [
    { code: 'es', label: 'ES' },
    { code: 'en', label: 'EN' },
    { code: 'fr', label: 'FR' },
    { code: 'pt', label: 'PT' },
];

const DICT = {
 "es": {
  "nav_historia": "Historia",
  "nav_mision": "Misión",
  "nav_vision": "Visión",
  "nav_servicios": "Servicios",
  "nav_casos": "Casos de éxito",
  "nav_arquitectura": "Arquitectura",
  "cta_agendar": "Agendar cita",
  "hero_eyebrow": "Agencia de marketing digital",
  "hero_tagline": "Crecemos contigo",
  "hero_value": "SEO, SEM, posicionamiento web, branding corporativo y digitalización de negocio. Convertimos marcas con raíces en árboles que crecen: estrategia orgánica y datos precisos para escalar tu empresa.",
  "cta_agenda": "Agenda tu cita",
  "cta_servicios": "Descubre los servicios",
  "metric_roi": "ROI medio",
  "metric_retencion": "Retención de clientes",
  "metric_proyectos": "Proyectos liderados",
  "hero_badge_t": "Crecemos contigo",
  "mq_0": "#PICHONTEAM",
  "mq_1": "GROWTH PARTNERS",
  "mq_2": "CRECEMOS CONTIGO",
  "mq_3": "SEO & SEM",
  "mq_4": "BRANDING CORPORATIVO",
  "mq_5": "DIGITALIZACIÓN DE NEGOCIO",
  "mq_6": "POSICIONAMIENTO WEB",
  "story_eyebrow": "Nuestra historia",
  "story_title": "Dos caminos, un hilo rojo",
  "scene_word": "Escena",
  "story1_label": "El origen",
  "story1_title": "Dos mundos paralelos",
  "story1_text": "Año 2022. Dos vidas discurriendo por caminos completamente separados. Él, sumergido en el vibrante mundo de la hostelería, el turismo y la operativa en pleno auge mediterráneo. Ella, transitando un camino tradicional y metódico entre números, empresa y logística, buscando algo que realmente la llenara. Aparentemente distantes, pero ambos compartiendo una chispa secreta: la creatividad.",
  "story2_label": "El punto de encuentro",
  "story2_title": "El hilo rojo",
  "story2_text": "Año 2023. El destino cruza nuestros caminos y comenzamos a tejer un hilo rojo. Sin saberlo al principio, ese hilo iría hilvanando una red invisible, el cimiento silencioso sobre el que construiríamos un nuevo proyecto de vida.",
  "story3_label": "La evolución y el aprendizaje",
  "story3_title": "Convergencia",
  "story3_text": "Entre 2023 y 2024, los proyectos personales y profesionales evolucionaron hacia una profunda convergencia. Nutriéndonos de nuestras propias experiencias y de las del otro, empezamos a dar forma a nuevas marcas y proyectos conjuntos, aprendiendo a complementarnos a la perfección.",
  "story4_label": "El gran reto",
  "story4_title": "El doble salto mortal",
  "story4_text": "Año 2025. Afrontamos la misión más difícil: una reconversión profesional radical. El reto de reinventarnos y, además, convertirnos en socios de un nuevo proyecto compartido, sumando el desafío de la vida en pareja y el matrimonio. No fue sencillo, pero nos fortaleció.",
  "story5_label": "El presente y el futuro",
  "story5_title": "Comunidad y liderazgo",
  "story5_text": "Hoy, en 2026, llenos de ilusión y esperanza, y por fin más unidos que nunca, lideramos un gran equipo de empresas, agentes y partners. Juntos impulsamos una red de colaboración mutua, caminando firmes hacia un crecimiento que es, al mismo tiempo, orgánico, digital y sostenible.",
  "mv_eyebrow": "Nuestro norte",
  "mv_title": "Misión y Visión",
  "mv_mision_t": "Misión",
  "mv_mision_main": "Transformar negocios tradicionales y digitales en marcas líderes mediante estrategias sostenibles, medibles y humanas.",
  "mv_mision_sub": "Trabajamos codo con codo con cada cliente: SEO, SEM, branding y digitalización al servicio de objetivos de negocio reales, no de vanidades.",
  "mv_vision_t": "Visión",
  "mv_vision_main": "Crecimiento compartido: diseñamos el camino para que ambos alcancemos nuestra mejor versión",
  "mv_vision_sub": "Tenemos como objetivo ser el partner estratégico de crecimiento más confiable del mercado hispanohablante.",
  "sv_eyebrow": "Servicios",
  "sv_title": "Cuatro pilares, un solo objetivo: crecer",
  "sv_intro": "Posicionamiento web, campañas de pago, marca y tecnología. Elige un pilar o combinamos los cuatro como Growth Partners.",
  "sv_ver_todos": "Ver todos los servicios",
  "caso_eyebrow": "Caso de éxito",
  "caso_estrategia": "La estrategia",
  "caso_desafio": "El desafío",
  "caso_back": "Todos los casos",
  "caso_ver": "Ver caso completo",
  "caso_antes": "Logo con carácter previo",
  "caso_despues": "Nueva propuesta de marca",
  "caso_paleta": "Paleta de colores diseñada",
  "caso_tipografia": "Tipografías de la marca",
  "caso_valor": "Propuesta de valor de marca",
  "caso_resultado": "Resultado",
  "caso_proceso": "Así trabajamos el cambio de marca",
  "caso_pendiente": "Contenido de marca en preparación: en cuanto lo tengamos, lo publicamos aquí.",
  "caso_otro": "Siguiente caso",
  "caso_cta": "¿Quieres resultados así? Hablemos.",
  "sv_ver": "Ver servicio",
  "pillar1_t": "Digitalización de negocio",
  "pillar1_d": "Llevamos tu operación al mundo digital: automatizaciones, CRM e infraestructura digital para trabajar mejor y vender más.",
  "pillar1_tag": "Impacto: eficiencia +40%",
  "pillar1_i1": "Automatización de procesos",
  "pillar1_i2": "Implantación de CRM",
  "pillar1_i3": "Infraestructura digital",
  "pillar1_i4": "Eficiencia operativa",
  "pillar2_t": "Branding corporativo",
  "pillar2_d": "Marcas con alma y sistema: de la arquitectura de marca al manual de estilo, todo pensado para posicionar.",
  "pillar2_tag": "Impacto: notoriedad de marca",
  "pillar2_i1": "Arquitectura de marca",
  "pillar2_i2": "Identidad visual",
  "pillar2_i3": "Posicionamiento de marca",
  "pillar2_i4": "Manual de estilo",
  "pillar3_t": "SEO y SEM",
  "pillar3_d": "Posicionamiento web orgánico y campañas de pago que se miden en ventas, no en impresiones.",
  "pillar3_tag": "Impacto: ROI publicitario",
  "pillar3_i1": "SEO orgánico y técnico",
  "pillar3_i2": "Google Ads y Meta PPC",
  "pillar3_i3": "Analítica web avanzada",
  "pillar3_i4": "CRO y testeo continuo",
  "pillar4_t": "Growth Partners",
  "pillar4_d": "Nuestro modelo de acompañamiento 360: estrategia, ejecución y datos contigo en cada decisión de crecimiento.",
  "pillar4_tag": "Impacto: crecimiento sostenido",
  "pillar4_i1": "Acompañamiento 360",
  "pillar4_i2": "Escalabilidad de ingresos",
  "pillar4_i3": "Estrategia de ingresos recurrentes",
  "pillar4_i4": "Comité mensual de growth",
  "casos_eyebrow": "Casos de éxito",
  "casos_title": "Historias reales, resultados medibles",
  "casos_intro": "Proyectos reales elaborados con nuestros clientes: marcas que hoy crecen con nosotros.",
  "casos_reto": "El reto: ",
  "casos_resultado": "El resultado: ",
  "casos_gato_reto": "Un negocio de hostelería con carácter propio que necesitaba una marca fuerte y procesos digitales para dar el salto.",
  "casos_gato_res": "+180% de incremento en la facturación global del negocio.",
  "casos_gato_metrica": "Facturación global",
  "casos_patrona_reto": "Una empresa de eventos que necesitaba una marca sólida, visibilidad online y procesos digitales para crecer.",
  "casos_patrona_res": "+75% de incremento en la facturación del último año.",
  "casos_patrona_metrica": "Facturación último año",
  "casos_burek_reto": "Un negocio de botánica que quería modernizarse y pasar a un modelo digital automatizado.",
  "casos_burek_res": "Conversión a un modelo de negocio con automatización digital completa.",
  "casos_burek_metrica": "Modelo de negocio",
  "casos_automatizado": "Automatizado",
  "casos_metrica2": "Conversión",
  "casos_ctr": "CTR medio",
  "casos_leads": "Leads/mes",
  "casos_google": "Google regional",
  "agenda_eyebrow": "Agenda tu cita",
  "agenda_title": "Empecemos a crecer contigo",
  "agenda_info_title": "Hablemos de tu negocio",
  "agenda_info_sub": "Primera sesión sin compromiso: analizamos tu punto de partida y te proponemos un plan de crecimiento a medida.",
  "agenda_label_nombre": "Nombre completo",
  "agenda_label_email": "Email",
  "agenda_label_telefono": "Teléfono",
  "agenda_label_empresa": "Empresa",
  "agenda_label_servicio": "Servicio de interés",
  "agenda_ph_servicio": "Elige un servicio",
  "agenda_label_fecha": "Fecha preferida",
  "agenda_label_mensaje": "Mensaje",
  "agenda_ph_mensaje": "Cuéntanos brevemente tu reto u objetivo...",
  "agenda_ph_nombre": "Tu nombre y apellidos",
  "agenda_ph_empresa": "Nombre de tu empresa",
  "agenda_btn_solicitar": "Solicitar cita",
  "agenda_btn_enviando": "Enviando...",
  "agenda_error": "Hubo un problema al enviar. Prueba otra vez.",
  "agenda_ok_title": "Cita solicitada",
  "agenda_ok_text": "Gracias{name}. Hemos registrado tu solicitud y te contactaremos en menos de 24 horas laborables para confirmar la fecha.",
  "agenda_ok_otra": "Enviar otra solicitud",
  "opt_seo": "SEO - Posicionamiento web",
  "opt_sem": "SEM - Campañas de pago",
  "opt_branding": "Branding corporativo",
  "opt_digital": "Digitalización de negocio",
  "opt_growth": "Growth Partners",
  "map_eyebrow": "Arquitectura web",
  "map_title": "Mapa de esta web, listo para SEO",
  "map_intro": "Esta es la estructura jerárquica del sitio, pensada para optimizar el rastreo e indexación en buscadores. Pasa el cursor por cada nodo para ver su URL y esquema.",
  "map_ia": "Arquitectura de la información",
  "map_note": "Estructura escalable: cada futuro caso de éxito vivirá en /casos-de-exito/[cliente]",
  "map_inicio": "Inicio - Home",
  "map_servicios": "Servicios",
  "map_casos": "Casos de éxito",
  "map_historia": "Nuestra historia",
  "map_agenda": "Agenda tu cita",
  "footer_tagline": "Crecemos contigo",
  "footer_volver": "Volver arriba",
  "footer_legal": "Aviso legal - Privacidad - Cookies",
  "footer_services_line": "SEO - SEM - Branding - Digitalización",
  "footer_lang": "Idioma",
  "wa_general": "Hola, me gustaría recibir más información sobre vuestros servicios.",
  "wa_branding": "Hola, estoy interesado/a en los servicios de Branding y me gustaría recibir más información.",
  "wa_digitalizacion": "Hola, estoy interesado/a en digitalizar mi negocio y me gustaría recibir más información.",
  "wa_automatizacion": "Hola, quiero conocer qué procesos podría automatizar en mi negocio.",
  "wa_seosem": "Hola, quiero mejorar la visibilidad y captación online de mi negocio.",
  "wa_growth": "Hola, estoy interesado/a en vuestro servicio Growth Partner y me gustaría saber cómo podríais ayudarme a hacer crecer mi negocio.",
  "wa_btn": "Hablar por WhatsApp",
  "wa_btn_nosotros": "Hablar con nosotros por WhatsApp",
  "sp_home_h1": "Servicios para hacer crecer tu negocio",
  "sp_home_intro": "Cinco áreas que trabajan juntas —branding, digitalización, automatización, SEO & SEM y Growth Partner— para que tu negocio atraiga más clientes y venda más.",
  "sp_descubrir": "Descubrir el servicio",
  "sp_home_cta": "¿No sabes por dónde empezar? Cuéntanos tu situación y te orientamos.",
  "sp_home_cta_sub": "Analizamos tu negocio y te recomendamos el servicio que más impacto puede tener ahora mismo.",
  "sp_explora": "Explora también",
  "sp_branding_short": "Una marca que se reconoce, se recuerda y transmite confianza.",
  "sp_digitalizacion_short": "Tu negocio convertido en una experiencia digital preparada para vender.",
  "sp_automatizacion_short": "Tu negocio trabajando incluso cuando tú no estás trabajando.",
  "sp_seosem_short": "Haz que te encuentren cuando tus clientes te están buscando.",
  "sp_growth_short": "No queremos ser otro proveedor: queremos hacer crecer tu negocio como si fuera nuestro.",
  "sp_name_branding": "Branding",
  "sp_name_digitalizacion": "Digitalización",
  "sp_name_automatizacion": "Automatización",
  "sp_name_seo-sem": "SEO & SEM",
  "sp_name_growth-partner": "Growth Partner",
  "branding_meta_t": "Branding corporativo: una marca que se recuerda | #PICHONTEAM",
  "branding_meta_d": "Creamos una identidad visual coherente para que tu negocio transmita profesionalidad y confianza: logo, imagen de marca, color, tipografía, merchandising e imagen digital.",
  "branding_h1": "Una marca que se reconoce, se recuerda y transmite confianza.",
  "branding_intro": "No se trata únicamente de tener un logo bonito. Creamos una identidad visual coherente para que tu negocio transmita profesionalidad, personalidad y confianza desde el primer vistazo.",
  "bi1_t": "Diseño y masterización de logo",
  "bi1_d": "Creación de un nuevo logotipo o profesionalización y perfeccionamiento del logo existente para conseguir una imagen sólida, reconocible y adaptable a cualquier formato.",
  "bi2_t": "Imagen de marca",
  "bi2_d": "Definición de la identidad visual completa del negocio para conseguir que todos los elementos comuniquen la misma personalidad.",
  "bi3_t": "Paleta de colores",
  "bi3_d": "Selección estratégica de colores principales y secundarios que representen la personalidad de la empresa y mantengan coherencia visual.",
  "bi4_t": "Tipografía",
  "bi4_d": "Selección y combinación de tipografías profesionales para títulos, textos, comunicaciones y soportes digitales.",
  "bi5_t": "Merchandising",
  "bi5_d": "Adaptación de la identidad visual a ropa, tarjetas, packaging, material comercial, vehículos u otros soportes físicos.",
  "bi6_t": "Imagen digital",
  "bi6_d": "Adaptación de la marca a web, redes sociales, anuncios, perfiles digitales, presentaciones y otros canales online.",
  "branding_cta": "¿Quieres construir una marca que la gente recuerde? Contáctanos para más información.",
  "digitalizacion_meta_t": "Digitalización de negocio: webs que venden | #PICHONTEAM",
  "digitalizacion_meta_d": "Landing pages, webs de alta conversión, SEO, catálogos digitales, redes sociales y e-commerce para transformar visitantes en clientes.",
  "digitalizacion_h1": "Convertimos tu negocio en una experiencia digital preparada para vender.",
  "digitalizacion_intro": "No basta con estar en Internet. Tu presencia digital debe transmitir confianza, ser fácil de utilizar y estar diseñada para transformar visitantes en clientes.",
  "di1_t": "Landing Pages",
  "di1_d": "Diseño de páginas específicas para presentar una oferta, captar contactos o conseguir ventas con una estructura enfocada a conversión.",
  "di2_t": "Webs de alta conversión",
  "di2_d": "Diseño y desarrollo de páginas web modernas, rápidas y estratégicamente estructuradas para convertir visitas en oportunidades comerciales.",
  "di3_t": "Web optimizada para SEO",
  "di3_d": "Estructuras, contenidos y elementos técnicos preparados para ayudar a Google a entender correctamente la web y mejorar progresivamente su posicionamiento.",
  "di4_t": "Catálogo digital",
  "di4_d": "Digitalización de productos y servicios mediante catálogos profesionales, visuales, fáciles de consultar y compartir.",
  "di5_t": "Redes sociales",
  "di5_d": "Diseño y optimización de la presencia visual del negocio en redes sociales para mantener una imagen profesional y coherente.",
  "di6_t": "E-commerce",
  "di6_d": "Creación de tiendas online diseñadas para facilitar el proceso de compra y aumentar las conversiones.",
  "digitalizacion_cta": "¿Quieres digitalizar tu negocio y empezar a generar oportunidades online? Contáctanos para más información.",
  "automatizacion_meta_t": "Automatización de negocio: procesos 24/7 | #PICHONTEAM",
  "automatizacion_meta_d": "Automatizamos citas, calendarios, paneles, dashboards, seguimientos y atención al cliente para ahorrar tiempo y atender más clientes sin más carga de trabajo.",
  "automatizacion_h1": "Haz que tu negocio trabaje incluso cuando tú no estás trabajando.",
  "automatizacion_intro": "Automatizamos procesos repetitivos para ahorrar tiempo, reducir errores y conseguir que tu empresa pueda atender más clientes sin aumentar innecesariamente la carga de trabajo.",
  "ai1_t": "Gestión automática de citas",
  "ai1_d": "Sistemas para que los clientes puedan consultar disponibilidad, reservar, modificar o cancelar citas automáticamente.",
  "ai2_t": "Gestión de calendario",
  "ai2_d": "Integración y automatización de calendarios para organizar citas, reuniones, disponibilidad y recordatorios.",
  "ai3_t": "Paneles de administración",
  "ai3_d": "Creación de paneles personalizados desde los que controlar clientes, servicios, citas, pedidos, leads u otras áreas importantes del negocio.",
  "ai4_t": "Dashboards",
  "ai4_d": "Paneles visuales con los principales datos y métricas del negocio para entender rápidamente qué está funcionando y qué necesita mejorar.",
  "ai5_t": "Automatización de negocio",
  "ai5_d": "Conexión y automatización de tareas repetitivas entre diferentes herramientas y procesos de la empresa.",
  "ai6_t": "Setter automatizado",
  "ai6_d": "Sistema para recibir, filtrar y cualificar potenciales clientes, realizar preguntas iniciales y dirigir cada oportunidad hacia el siguiente paso comercial.",
  "ai7_t": "Asistente / contestador automático",
  "ai7_d": "Sistemas automáticos de respuesta para web y canales digitales capaces de responder preguntas frecuentes, recoger información y ayudar al cliente 24/7.",
  "ai8_t": "Automatización de seguimiento",
  "ai8_d": "Creación de procesos automáticos para realizar seguimientos, enviar recordatorios y evitar que oportunidades comerciales se pierdan por falta de respuesta.",
  "automatizacion_cta": "Menos tareas repetitivas. Más tiempo para hacer crecer tu negocio. Contáctanos para más información.",
  "seosem_meta_t": "SEO & SEM: aparece cuando te buscan | #PICHONTEAM",
  "seosem_meta_d": "Te explicamos el SEO y el SEM de forma sencilla y te ayudamos a aparecer en los primeros resultados de Google con estrategias sostenibles y campañas efectivas.",
  "seosem_h1": "Haz que te encuentren cuando tus clientes te están buscando.",
  "seosem_h2_dos": "Dos formas de aparecer en Google",
  "seosem_h2_intro": "Que te encuentren en Internet se reduce, en gran parte, a dos estrategias complementarias. Te lo explicamos sin palabras técnicas.",
  "seosem_seo_t": "Crecer de forma orgánica",
  "seosem_seo_p1": "Imagina que Google es una calle llena de negocios. El SEO consiste en conseguir que Google considere que tu negocio es uno de los mejores sitios que puede recomendar cuando alguien busca lo que tú vendes.",
  "seosem_seo_p2": "No pagas a Google por cada visita. Trabajamos tu web, contenidos, estructura, autoridad y otros factores para intentar mejorar progresivamente tu posición en los resultados de búsqueda.",
  "seosem_seo_p3": "Es una estrategia que normalmente necesita tiempo, pero puede generar resultados sostenibles a medio y largo plazo.",
  "seosem_sem_t": "Conseguir visibilidad mediante publicidad",
  "seosem_sem_p1": "El SEM permite pagar para mostrar anuncios a personas que están buscando determinados productos o servicios.",
  "seosem_sem_p2": "Utilizamos plataformas publicitarias como Google Ads y Meta Ads para llevar potenciales clientes hacia una oferta, landing page o proceso de captación.",
  "seosem_sem_p3": "A diferencia del SEO, permite conseguir visibilidad y tráfico de forma mucho más rápida, pero requiere inversión publicitaria.",
  "seosem_h2_pq": "¿Por qué importa aparecer en los primeros puestos de Google?",
  "seosem_pq_p1": "Cuando necesitas un restaurante, un abogado, una clínica o cualquier otro servicio, normalmente buscas en Google y empiezas mirando los primeros resultados. Tus clientes hacen exactamente lo mismo.",
  "seosem_pq_p2": "Estar entre las primeras opciones significa aumentar las posibilidades de que entren en tu web, conozcan tu negocio y terminen contactándote en lugar de contactar con tu competencia.",
  "seosem_nota": "La diferencia principal: en SEO no se paga directamente por cada clic, mientras que en campañas SEM sí existe inversión publicitaria. El trabajo, la estrategia y los recursos están presentes en ambas.",
  "seosem_cta": "¿Quieres que tus clientes te encuentren antes que a tu competencia? Contáctanos para más información.",
  "growth_meta_t": "Growth Partner: crecemos contigo | #PICHONTEAM",
  "growth_meta_d": "Analizamos tu negocio, diseñamos una oferta ganadora y construimos un embudo de conversión completo: estrategia, tecnología y automatización alineadas con tu crecimiento.",
  "growth_h1": "No queremos ser otro proveedor. Queremos hacer crecer tu negocio como si fuera nuestro.",
  "growth_intro": "Nuestro servicio de Growth Partner parte de una idea sencilla: cada empresa es diferente. En lugar de vender un paquete cerrado de servicios, analizamos tu negocio, detectamos dónde están las principales oportunidades de crecimiento y construimos una estrategia adaptada a tus objetivos. Nuestro crecimiento está alineado con el crecimiento de nuestros clientes.",
  "growth_modelo": "Nuestro modelo",
  "g1_t": "Analizamos tu negocio",
  "g1_d": "Estudiamos producto, cliente, competencia, posicionamiento y proceso comercial.",
  "g2_t": "Diseñamos una oferta ganadora",
  "g2_d": "Construimos o mejoramos una oferta capaz de captar la atención del cliente ideal y darle razones claras para elegirte.",
  "g3_t": "Creamos los elementos de alta conversión",
  "g3_d": "Diseñamos los recursos y creatividades necesarios para presentar esa oferta de forma convincente en landing pages, publicidad y redes sociales.",
  "g4_t": "Construimos el embudo",
  "g4_d": "Diseñamos el recorrido desde que una persona descubre el negocio hasta que se convierte en oportunidad comercial o cliente.",
  "g5_t": "Automatizamos",
  "g5_d": "Automatizamos captación, seguimiento, citas y procesos cuando sea necesario para reducir fricción y evitar perder oportunidades.",
  "g6_t": "Medimos y optimizamos",
  "g6_d": "Analizamos los datos para detectar qué funciona, mejorar lo que no funciona y aumentar progresivamente la conversión.",
  "flow_0": "Tráfico",
  "flow_1": "Oferta",
  "flow_2": "Landing Page",
  "flow_3": "Lead",
  "flow_4": "Seguimiento",
  "flow_5": "Venta",
  "growth_msj_eyebrow": "Nuestra forma de trabajar",
  "growth_msj_main": "No aplicamos la misma fórmula a todos los negocios. Nos adaptamos al cliente, a su mercado, a sus objetivos y a su situación actual.",
  "growth_msj_sub": "Actuamos como un socio estratégico de crecimiento: branding, tecnología, captación, conversión y automatización trabajando conjuntamente con un único objetivo: hacer crecer el negocio.",
  "growth_cta_h": "¿Quieres que analicemos cómo podemos hacer crecer tu negocio?",
  "growth_cta_sub": "Cuéntanos tu situación y estudiaremos qué estrategia tiene más sentido para ti.",
  "growth_cta_prefer": "¿Prefieres agendar una llamada? ",
  "growth_cta_link": "Agenda tu cita aquí",
  "sp_meta_t": "Servicios | #PICHONTEAM Growth Partners",
  "sp_meta_d": "Branding, digitalización, automatización, SEO & SEM y Growth Partner: servicios para hacer crecer tu negocio.",
  "llamamos_cerrar": "Cerrar",
  "llamamos_btn": "¿Te llamamos?",
  "llamamos_title": "Te llamamos",
  "llamamos_sub": "Déjanos tu nombre y teléfono y te llamamos sin compromiso.",
  "llamamos_nombre": "Nombre",
  "llamamos_telefono": "Teléfono",
  "llamamos_ph_nombre": "Tu nombre",
  "llamamos_ph_telefono": "Tu número de teléfono",
  "llamamos_send": "Sí, llamadme",
  "llamamos_enviando": "Enviando...",
  "llamamos_ok_t": "Solicitud recibida",
  "llamamos_ok_text": "Gracias{name}. Te llamamos muy pronto.",
  "llamamos_error": "No se pudo enviar. Inténtalo de nuevo."
 },
 "en": {
  "nav_historia": "Our story",
  "nav_mision": "Mission",
  "nav_vision": "Vision",
  "nav_servicios": "Services",
  "nav_casos": "Success stories",
  "nav_arquitectura": "Architecture",
  "cta_agendar": "Book a call",
  "hero_eyebrow": "Digital marketing agency",
  "hero_tagline": "We grow with you",
  "hero_value": "SEO, SEM, web positioning, corporate branding and business digitalization. We turn brands with roots into growing trees: organic strategy and precise data to scale your company.",
  "cta_agenda": "Book a call",
  "cta_servicios": "Discover our services",
  "metric_roi": "Average ROI",
  "metric_retencion": "Client retention",
  "metric_proyectos": "Projects led",
  "hero_badge_t": "We grow with you",
  "mq_0": "#PICHONTEAM",
  "mq_1": "GROWTH PARTNERS",
  "mq_2": "WE GROW WITH YOU",
  "mq_3": "SEO & SEM",
  "mq_4": "CORPORATE BRANDING",
  "mq_5": "BUSINESS DIGITALIZATION",
  "mq_6": "WEB POSITIONING",
  "story_eyebrow": "Our story",
  "story_title": "Two paths, one red thread",
  "scene_word": "Scene",
  "story1_label": "The origin",
  "story1_title": "Two parallel worlds",
  "story1_text": "Year 2022. Two lives running on completely separate paths. He, immersed in the vibrant world of hospitality, tourism and operations in the booming Mediterranean. She, following a traditional, methodical path among numbers, business and logistics, searching for something that truly fulfilled her. Seemingly distant, yet both sharing a secret spark: creativity.",
  "story2_label": "The meeting point",
  "story2_title": "The red thread",
  "story2_text": "Year 2023. Destiny crosses our paths and we begin to weave a red thread. Without knowing it at first, that thread would stitch an invisible web, the silent foundation on which we would build a new life project.",
  "story3_label": "Evolution and learning",
  "story3_title": "Convergence",
  "story3_text": "Between 2023 and 2024, our personal and professional projects evolved into a deep convergence. Nourished by our own experiences and by each other’s, we began shaping new brands and joint projects, learning to complement each other perfectly.",
  "story4_label": "The great challenge",
  "story4_title": "The double somersault",
  "story4_text": "Year 2025. We faced our hardest mission: a radical career reinvention. The challenge of reinventing ourselves and, on top of that, becoming partners in a new shared project, adding the challenge of life as a couple and marriage. It was not easy, but it made us stronger.",
  "story5_label": "The present and future",
  "story5_title": "Community and leadership",
  "story5_text": "Today, in 2026, full of excitement and hope, and finally more united than ever, we lead a large team of companies, agents and partners. Together we drive a network of mutual collaboration, moving steadily toward growth that is, at the same time, organic, digital and sustainable.",
  "mv_eyebrow": "Our compass",
  "mv_title": "Mission & Vision",
  "mv_mision_t": "Mission",
  "mv_mision_main": "We transform traditional and digital businesses into leading brands through sustainable, measurable and human strategies.",
  "mv_mision_sub": "We work side by side with every client: SEO, SEM, branding and digitalization serving real business goals, not vanity metrics.",
  "mv_vision_t": "Vision",
  "mv_vision_main": "Shared growth: we design the path so that both of us reach our best version",
  "mv_vision_sub": "Our goal is to be the most trusted growth partner in the Spanish-speaking market.",
  "sv_eyebrow": "Services",
  "sv_title": "Four pillars, one goal: growth",
  "sv_intro": "Web positioning, paid campaigns, brand and technology. Choose one pillar or combine all four as Growth Partners.",
  "sv_ver_todos": "View all services",
  "caso_eyebrow": "Success story",
  "caso_estrategia": "The strategy",
  "caso_desafio": "The challenge",
  "caso_back": "All cases",
  "caso_ver": "View full case",
  "caso_antes": "Original logo",
  "caso_despues": "New brand proposal",
  "caso_paleta": "Designed color palette",
  "caso_tipografia": "Brand typography",
  "caso_valor": "Brand value proposition",
  "caso_resultado": "Result",
  "caso_proceso": "How we approached the rebrand",
  "caso_pendiente": "Brand content in progress: we will publish it here as soon as it is ready.",
  "caso_otro": "Next case",
  "caso_cta": "Want results like this? Let's talk.",
  "sv_ver": "View service",
  "pillar1_t": "Business digitalization",
  "pillar1_d": "We take your operations into the digital world: automations, CRM and digital infrastructure to work better and sell more.",
  "pillar1_tag": "Impact: +40% efficiency",
  "pillar1_i1": "Process automation",
  "pillar1_i2": "CRM implementation",
  "pillar1_i3": "Digital infrastructure",
  "pillar1_i4": "Operational efficiency",
  "pillar2_t": "Corporate branding",
  "pillar2_d": "Brands with soul and system: from brand architecture to style guide, everything designed to position you.",
  "pillar2_tag": "Impact: brand awareness",
  "pillar2_i1": "Brand architecture",
  "pillar2_i2": "Visual identity",
  "pillar2_i3": "Brand positioning",
  "pillar2_i4": "Style guide",
  "pillar3_t": "SEO & SEM",
  "pillar3_d": "Organic web positioning and paid campaigns measured in sales, not impressions.",
  "pillar3_tag": "Impact: ad ROI",
  "pillar3_i1": "Organic & technical SEO",
  "pillar3_i2": "Google Ads & Meta PPC",
  "pillar3_i3": "Advanced web analytics",
  "pillar3_i4": "CRO & continuous testing",
  "pillar4_t": "Growth Partners",
  "pillar4_d": "Our 360° support model: strategy, execution and data with you in every growth decision.",
  "pillar4_tag": "Impact: sustained growth",
  "pillar4_i1": "360° support",
  "pillar4_i2": "Revenue scalability",
  "pillar4_i3": "Recurring revenue strategy",
  "pillar4_i4": "Monthly growth committee",
  "casos_eyebrow": "Success stories",
  "casos_title": "Real stories, measurable results",
  "casos_intro": "Real projects built with our clients: brands that grow with us today.",
  "casos_reto": "The challenge: ",
  "casos_resultado": "The result: ",
  "casos_gato_reto": "A hospitality business with its own character that needed a strong brand and digital processes to make the leap.",
  "casos_gato_res": "+180% increase in the business’s overall revenue.",
  "casos_gato_metrica": "Overall revenue",
  "casos_patrona_reto": "An events company that needed a solid brand, online visibility and digital processes to grow.",
  "casos_patrona_res": "+75% revenue increase over the last year.",
  "casos_patrona_metrica": "Revenue last year",
  "casos_burek_reto": "A botanical business that wanted to modernize and move to an automated digital model.",
  "casos_burek_res": "Converted to a business model with complete digital automation.",
  "casos_burek_metrica": "Business model",
  "casos_automatizado": "Automated",
  "casos_metrica2": "Conversion",
  "casos_ctr": "Avg. CTR",
  "casos_leads": "Leads/month",
  "casos_google": "Regional Google",
  "agenda_eyebrow": "Book a call",
  "agenda_title": "Let’s start growing together",
  "agenda_info_title": "Let’s talk about your business",
  "agenda_info_sub": "A first session with no commitment: we analyze your starting point and propose a tailored growth plan.",
  "agenda_label_nombre": "Full name",
  "agenda_label_email": "Email",
  "agenda_label_telefono": "Phone",
  "agenda_label_empresa": "Company",
  "agenda_label_servicio": "Service of interest",
  "agenda_ph_servicio": "Choose a service",
  "agenda_label_fecha": "Preferred date",
  "agenda_label_mensaje": "Message",
  "agenda_ph_mensaje": "Briefly tell us your challenge or goal...",
  "agenda_ph_nombre": "Your full name",
  "agenda_ph_empresa": "Your company name",
  "agenda_btn_solicitar": "Request appointment",
  "agenda_btn_enviando": "Sending...",
  "agenda_error": "Something went wrong. Please try again.",
  "agenda_ok_title": "Appointment requested",
  "agenda_ok_text": "Thank you{name}. We have registered your request and will contact you within 24 working hours to confirm the date.",
  "agenda_ok_otra": "Send another request",
  "opt_seo": "SEO - Web positioning",
  "opt_sem": "SEM - Paid campaigns",
  "opt_branding": "Corporate branding",
  "opt_digital": "Business digitalization",
  "opt_growth": "Growth Partners",
  "map_eyebrow": "Web architecture",
  "map_title": "The map of this site, ready for SEO",
  "map_intro": "This is the site’s hierarchical structure, designed to optimize crawling and indexing. Hover each node to see its URL and schema.",
  "map_ia": "Information architecture",
  "map_note": "Scalable structure: every future success story will live at /casos-de-exito/[client]",
  "map_inicio": "Home",
  "map_servicios": "Services",
  "map_casos": "Success stories",
  "map_historia": "Our story",
  "map_agenda": "Book a call",
  "footer_tagline": "We grow with you",
  "footer_volver": "Back to top",
  "footer_legal": "Legal notice - Privacy - Cookies",
  "footer_services_line": "SEO - SEM - Branding - Digitalization",
  "footer_lang": "Language",
  "wa_general": "Hello, I would like more information about your services.",
  "wa_branding": "Hello, I am interested in your Branding services and would like more information.",
  "wa_digitalizacion": "Hello, I am interested in digitalizing my business and would like more information.",
  "wa_automatizacion": "Hello, I want to find out which processes I could automate in my business.",
  "wa_seosem": "Hello, I want to improve my business’s online visibility and lead generation.",
  "wa_growth": "Hello, I am interested in your Growth Partner service and would like to know how you could help me grow my business.",
  "wa_btn": "Chat on WhatsApp",
  "wa_btn_nosotros": "Talk to us on WhatsApp",
  "sp_home_h1": "Services to grow your business",
  "sp_home_intro": "Five areas working together —branding, digitalization, automation, SEO & SEM and Growth Partner— so your business attracts more clients and sells more.",
  "sp_descubrir": "Discover the service",
  "sp_home_cta": "Don’t know where to start? Tell us your situation and we’ll point you in the right direction.",
  "sp_home_cta_sub": "We analyze your business and recommend the service with the most impact right now.",
  "sp_explora": "Explore also",
  "sp_branding_short": "A brand that gets recognized, remembered and trusted.",
  "sp_digitalizacion_short": "Your business turned into a digital experience ready to sell.",
  "sp_automatizacion_short": "Your business working even when you are not working.",
  "sp_seosem_short": "Get found when your clients are searching for you.",
  "sp_growth_short": "We don’t want to be another vendor: we want to grow your business as if it were ours.",
  "sp_name_branding": "Branding",
  "sp_name_digitalizacion": "Digitalization",
  "sp_name_automatizacion": "Automation",
  "sp_name_seo-sem": "SEO & SEM",
  "sp_name_growth-partner": "Growth Partner",
  "branding_meta_t": "Corporate branding: a brand people remember | #PICHONTEAM",
  "branding_meta_d": "We create a coherent visual identity so your business conveys professionalism and trust: logo, brand image, color, typography, merchandising and digital image.",
  "branding_h1": "A brand that gets recognized, remembered and trusted.",
  "branding_intro": "It is not just about having a pretty logo. We create a coherent visual identity so your business conveys professionalism, personality and trust from the very first glance.",
  "bi1_t": "Logo design and refinement",
  "bi1_d": "Creation of a new logo, or professional refinement of your existing one, to achieve a solid, recognizable image adaptable to any format.",
  "bi2_t": "Brand image",
  "bi2_d": "Definition of the complete visual identity of the business so every element communicates the same personality.",
  "bi3_t": "Color palette",
  "bi3_d": "Strategic selection of primary and secondary colors that represent the company’s personality and keep visual coherence.",
  "bi4_t": "Typography",
  "bi4_d": "Selection and combination of professional typefaces for titles, texts, communications and digital media.",
  "bi5_t": "Merchandising",
  "bi5_d": "Adapting the visual identity to clothing, cards, packaging, commercial material, vehicles or other physical media.",
  "bi6_t": "Digital image",
  "bi6_d": "Adapting the brand to web, social media, ads, digital profiles, presentations and other online channels.",
  "branding_cta": "Want to build a brand people remember? Contact us for more information.",
  "digitalizacion_meta_t": "Business digitalization: websites that sell | #PICHONTEAM",
  "digitalizacion_meta_d": "Landing pages, high-conversion websites, SEO, digital catalogs, social media and e-commerce to turn visitors into clients.",
  "digitalizacion_h1": "We turn your business into a digital experience ready to sell.",
  "digitalizacion_intro": "Being on the Internet is not enough. Your digital presence must convey trust, be easy to use and be designed to turn visitors into clients.",
  "di1_t": "Landing Pages",
  "di1_d": "Design of dedicated pages to present an offer, capture contacts or drive sales with a conversion-focused structure.",
  "di2_t": "High-conversion websites",
  "di2_d": "Design and development of modern, fast, strategically structured websites that turn visits into business opportunities.",
  "di3_t": "SEO-optimized website",
  "di3_d": "Structures, content and technical elements prepared to help Google properly understand the website and progressively improve its ranking.",
  "di4_t": "Digital catalog",
  "di4_d": "Digitalization of products and services through professional, visual catalogs that are easy to browse and share.",
  "di5_t": "Social media",
  "di5_d": "Design and optimization of the business’s visual presence on social media to keep a professional, coherent image.",
  "di6_t": "E-commerce",
  "di6_d": "Creation of online stores designed to streamline the buying process and increase conversions.",
  "digitalizacion_cta": "Want to digitalize your business and start generating online opportunities? Contact us for more information.",
  "automatizacion_meta_t": "Business automation: 24/7 processes | #PICHONTEAM",
  "automatizacion_meta_d": "We automate appointments, calendars, admin panels, dashboards, follow-ups and customer service to save time and serve more clients without extra workload.",
  "automatizacion_h1": "Make your business work even when you are not working.",
  "automatizacion_intro": "We automate repetitive processes to save time, reduce errors and help your company serve more clients without unnecessarily increasing the workload.",
  "ai1_t": "Automated appointment management",
  "ai1_d": "Systems so clients can check availability and book, reschedule or cancel appointments automatically.",
  "ai2_t": "Calendar management",
  "ai2_d": "Calendar integration and automation to organize appointments, meetings, availability and reminders.",
  "ai3_t": "Admin panels",
  "ai3_d": "Creation of custom panels from which to manage clients, services, appointments, orders, leads or other key areas of the business.",
  "ai4_t": "Dashboards",
  "ai4_d": "Visual panels with the business’s key data and metrics to quickly understand what is working and what needs improvement.",
  "ai5_t": "Business automation",
  "ai5_d": "Connecting and automating repetitive tasks across the company’s different tools and processes.",
  "ai6_t": "Automated setter",
  "ai6_d": "A system to receive, filter and qualify potential clients, ask initial questions and move each opportunity to the next sales step.",
  "ai7_t": "Assistant / auto-responder",
  "ai7_d": "Automatic response systems for web and digital channels that answer FAQs, collect information and help clients 24/7.",
  "ai8_t": "Follow-up automation",
  "ai8_d": "Building automatic processes for follow-ups and reminders so business opportunities are never lost to a missing reply.",
  "automatizacion_cta": "Fewer repetitive tasks. More time to grow your business. Contact us for more information.",
  "seosem_meta_t": "SEO & SEM: get found when they search | #PICHONTEAM",
  "seosem_meta_d": "We explain SEO and SEM in simple terms and help you reach the top Google results with sustainable strategies and effective campaigns.",
  "seosem_h1": "Get found when your clients are searching for you.",
  "seosem_h2_dos": "Two ways to appear on Google",
  "seosem_h2_intro": "Being found on the Internet comes down, to a large extent, to two complementary strategies. We explain it without technical words.",
  "seosem_seo_t": "Growing organically",
  "seosem_seo_p1": "Imagine Google is a street full of businesses. SEO means getting Google to see your business as one of the best places it can recommend when someone searches for what you sell.",
  "seosem_seo_p2": "You don’t pay Google for every visit. We work on your website, content, structure, authority and other factors to progressively improve your position in search results.",
  "seosem_seo_p3": "It is a strategy that usually takes time, but can deliver sustainable medium and long-term results.",
  "seosem_sem_t": "Getting visibility through advertising",
  "seosem_sem_p1": "SEM allows you to pay to show ads to people who are searching for specific products or services.",
  "seosem_sem_p2": "We use advertising platforms such as Google Ads and Meta Ads to bring potential clients to an offer, landing page or lead capture process.",
  "seosem_sem_p3": "Unlike SEO, it delivers visibility and traffic much faster, but requires advertising investment.",
  "seosem_h2_pq": "Why does ranking at the top of Google matter?",
  "seosem_pq_p1": "When you need a restaurant, a lawyer, a clinic or any other service, you usually search on Google and start with the first results. Your clients do exactly the same.",
  "seosem_pq_p2": "Being among the first options increases the chances that they visit your website, get to know your business and end up contacting you instead of your competition.",
  "seosem_nota": "The key difference: with SEO you don’t pay directly for each click, while SEM campaigns do involve advertising investment. Work, strategy and resources are present in both.",
  "seosem_cta": "Want your clients to find you before your competition? Contact us for more information.",
  "growth_meta_t": "Growth Partner: we grow with you | #PICHONTEAM",
  "growth_meta_d": "We analyze your business, design a winning offer and build a complete conversion funnel: strategy, technology and automation aligned with your growth.",
  "growth_h1": "We don’t want to be another vendor. We want to grow your business as if it were ours.",
  "growth_intro": "Our Growth Partner service starts from a simple idea: every company is different. Instead of selling a closed package of services, we analyze your business, detect where the main growth opportunities are and build a strategy tailored to your goals. Our growth is aligned with our clients’ growth.",
  "growth_modelo": "Our model",
  "g1_t": "We analyze your business",
  "g1_d": "We study product, client, competition, positioning and sales process.",
  "g2_t": "We design a winning offer",
  "g2_d": "We build or improve an offer that captures your ideal client’s attention and gives them clear reasons to choose you.",
  "g3_t": "We create high-conversion assets",
  "g3_d": "We design the assets and creatives needed to present that offer convincingly on landing pages, advertising and social media.",
  "g4_t": "We build the funnel",
  "g4_d": "We design the journey from the moment someone discovers the business until they become a sales opportunity or client.",
  "g5_t": "We automate",
  "g5_d": "We automate lead capture, follow-up, appointments and processes when needed to reduce friction and avoid losing opportunities.",
  "g6_t": "We measure and optimize",
  "g6_d": "We analyze data to detect what works, improve what doesn’t and progressively increase conversion.",
  "flow_0": "Traffic",
  "flow_1": "Offer",
  "flow_2": "Landing Page",
  "flow_3": "Lead",
  "flow_4": "Follow-up",
  "flow_5": "Sale",
  "growth_msj_eyebrow": "How we work",
  "growth_msj_main": "We don’t apply the same formula to every business. We adapt to the client, their market, their goals and their current situation.",
  "growth_msj_sub": "We act as a strategic growth partner: branding, technology, lead generation, conversion and automation working together with a single goal: growing the business.",
  "growth_cta_h": "Want us to analyze how we can grow your business?",
  "growth_cta_sub": "Tell us your situation and we’ll study which strategy makes the most sense for you.",
  "growth_cta_prefer": "Prefer to book a call? ",
  "growth_cta_link": "Book a call here",
  "sp_meta_t": "Services | #PICHONTEAM Growth Partners",
  "sp_meta_d": "Branding, digitalization, automation, SEO & SEM and Growth Partner: services to grow your business.",
  "llamamos_cerrar": "Close",
  "llamamos_btn": "Shall we call you?",
  "llamamos_title": "We’ll call you",
  "llamamos_sub": "Leave your name and phone number and we’ll call you, no strings attached.",
  "llamamos_nombre": "Name",
  "llamamos_telefono": "Phone number",
  "llamamos_ph_nombre": "Your name",
  "llamamos_ph_telefono": "Your phone number",
  "llamamos_send": "Yes, call me",
  "llamamos_enviando": "Sending...",
  "llamamos_ok_t": "Request received",
  "llamamos_ok_text": "Thank you{name}. We’ll call you very soon.",
  "llamamos_error": "Could not send. Please try again."
 },
 "fr": {
  "nav_historia": "Notre histoire",
  "nav_mision": "Mission",
  "nav_vision": "Vision",
  "nav_servicios": "Services",
  "nav_casos": "Réussites",
  "nav_arquitectura": "Architecture",
  "cta_agendar": "Prendre rendez-vous",
  "hero_eyebrow": "Agence de marketing digital",
  "hero_tagline": "Nous grandissons avec vous",
  "hero_value": "SEO, SEM, référencement web, branding d'entreprise et digitalisation des entreprises. Nous transformons les marques enracinées en arbres qui grandissent : stratégie organique et données précises pour faire évoluer votre entreprise.",
  "cta_agenda": "Prendre rendez-vous",
  "cta_servicios": "Découvrir les services",
  "metric_roi": "ROI moyen",
  "metric_retencion": "Fidélisation clients",
  "metric_proyectos": "Projets menés",
  "hero_badge_t": "Nous grandissons avec vous",
  "mq_0": "#PICHONTEAM",
  "mq_1": "GROWTH PARTNERS",
  "mq_2": "NOUS GRANDISSONS AVEC VOUS",
  "mq_3": "SEO & SEM",
  "mq_4": "BRANDING D'ENTREPRISE",
  "mq_5": "DIGITALISATION DES ENTREPRISES",
  "mq_6": "RÉFÉRENCEMENT WEB",
  "story_eyebrow": "Notre histoire",
  "story_title": "Deux chemins, un fil rouge",
  "scene_word": "Scène",
  "story1_label": "L'origine",
  "story1_title": "Deux mondes parallèles",
  "story1_text": "Année 2022. Deux vies qui suivent des chemins totalement séparés. Lui, plongé dans l'univers vibrant de l'hôtellerie-restauration, du tourisme et des opérations dans une Méditerranée en plein essor. Elle, sur un chemin traditionnel et méthodique entre chiffres, entreprise et logistique, cherchant quelque chose qui la comble vraiment. Apparemment distants, mais partageant tous les deux une étincelle secrète : la créativité.",
  "story2_label": "Le point de rencontre",
  "story2_title": "Le fil rouge",
  "story2_text": "Année 2023. Le destin croise nos chemins et nous commençons à tisser un fil rouge. Sans le savoir au début, ce fil allait ourdir une toile invisible, le socle silencieux sur lequel nous allions construire un nouveau projet de vie.",
  "story3_label": "L'évolution et l'apprentissage",
  "story3_title": "Convergence",
  "story3_text": "Entre 2023 et 2024, nos projets personnels et professionnels ont évolué vers une profonde convergence. En nous nourrissant de nos expériences propres et de celles de l'autre, nous avons commencé à donner forme à de nouvelles marques et à des projets communs, en apprenant à nous compléter à la perfection.",
  "story4_label": "Le grand défi",
  "story4_title": "Le double saut périlleux",
  "story4_text": "Année 2025. Nous avons affronté notre mission la plus difficile : une reconversion professionnelle radicale. Le défi de nous réinventer et, de surcroît, devenir associés d'un nouveau projet commun, en ajoutant le défi de la vie de couple et du mariage. Ce ne fut pas simple, mais cela nous a renforcés.",
  "story5_label": "Le présent et l’avenir",
  "story5_title": "Communauté et leadership",
  "story5_text": "Aujourd'hui, en 2026, remplis d'illusion et d'espoir, et enfin plus unis que jamais, nous dirigeons une grande équipe d'entreprises, d'agents et de partenaires. Ensemble, nous impulsons un réseau de collaboration mutuelle, en avançant fermement vers une croissance à la fois organique, digitale et durable.",
  "mv_eyebrow": "Notre cap",
  "mv_title": "Mission & Vision",
  "mv_mision_t": "Mission",
  "mv_mision_main": "Nous transformons les entreprises traditionnelles et digitales en marques de référence grâce à des stratégies durables, mesurables et humaines.",
  "mv_mision_sub": "Nous travaillons main dans la main avec chaque client : SEO, SEM, branding et digitalisation au service d'objectifs commerciaux réels, pas de la vanité.",
  "mv_vision_t": "Vision",
  "mv_vision_main": "Une croissance partagée : nous dessinons le chemin pour que chacun atteigne sa meilleure version",
  "mv_vision_sub": "Notre objectif est d'être le partenaire de croissance le plus fiable du marché hispanophone.",
  "sv_eyebrow": "Services",
  "sv_title": "Quatre piliers, un seul objectif : grandir",
  "sv_intro": "Référencement, campagnes payantes, marque et technologie. Choisissez un pilier ou combinez-les tous en tant que Growth Partners.",
  "sv_ver_todos": "Voir tous les services",
  "caso_eyebrow": "Réussite client",
  "caso_estrategia": "La stratégie",
  "caso_desafio": "Le défi",
  "caso_back": "Tous les cas",
  "caso_ver": "Voir le cas complet",
  "caso_antes": "Logo d'origine",
  "caso_despues": "Nouvelle proposition de marque",
  "caso_paleta": "Palette de couleurs conçue",
  "caso_tipografia": "Typographies de la marque",
  "caso_valor": "Proposition de valeur de marque",
  "caso_resultado": "Résultat",
  "caso_proceso": "Notre approche du changement de marque",
  "caso_pendiente": "Contenu de marque en préparation : nous le publierons ici dès qu'il sera prêt.",
  "caso_otro": "Cas suivant",
  "caso_cta": "Envie de résultats comme ceux-ci ? Parlons-en.",
  "sv_ver": "Voir le service",
  "pillar1_t": "Digitalisation des entreprises",
  "pillar1_d": "Nous emmenons votre activité dans le monde digital : automatisations, CRM et infrastructure digitale pour mieux travailler et vendre plus.",
  "pillar1_tag": "Impact : efficacité +40 %",
  "pillar1_i1": "Automatisation des processus",
  "pillar1_i2": "Despliegue de CRM",
  "pillar1_i3": "Infrastructure digitale",
  "pillar1_i4": "Eficacia operacional",
  "pillar2_t": "Branding d'entreprise",
  "pillar2_d": "Des marques avec âme et système : de l'architecture de marque au manuel de style, tout est pensé pour vous positionner.",
  "pillar2_tag": "Impact : notoriété de marque",
  "pillar2_i1": "Architecture de marque",
  "pillar2_i2": "Identité visuelle",
  "pillar2_i3": "Positionnement de marque",
  "pillar2_i4": "Manuel de style",
  "pillar3_t": "SEO & SEM",
  "pillar3_d": "Référencement organique et campagnes payantes mesurées en ventes, pas en impressions.",
  "pillar3_tag": "Impact : ROI publicitaire",
  "pillar3_i1": "SEO organique et technique",
  "pillar3_i2": "Google Ads et Meta PPC",
  "pillar3_i3": "Analytique web avancée",
  "pillar3_i4": "CRO et tests continus",
  "pillar4_t": "Growth Partners",
  "pillar4_d": "Notre modèle d'accompagnement 360 : stratégie, exécution et données à vos côtés à chaque décision de croissance.",
  "pillar4_tag": "Impact : croissance durable",
  "pillar4_i1": "Accompagnement 360",
  "pillar4_i2": "Scalabilité des revenus",
  "pillar4_i3": "Stratégie de revenus récurrents",
  "pillar4_i4": "Comité growth mensual",
  "casos_eyebrow": "Réussites",
  "casos_title": "Histoires réelles, résultats mesurables",
  "casos_intro": "Des projets réels menés avec nos clients : des marques qui grandissent avec nous aujourd'hui.",
  "casos_reto": "Le défi : ",
  "casos_resultado": "Le résultat : ",
  "casos_gato_reto": "Un établissement d'hôtellerie-restauration au caractère bien trempé qui avait besoin d'une marque forte et de processus digitaux pour franchir le cap.",
  "casos_gato_res": "+180 % d’augmentation du chiffre d’affaires global de l’entreprise.",
  "casos_gato_metrica": "Chiffre d’affaires global",
  "casos_patrona_reto": "Une entreprise événementielle qui avait besoin d’une marque solide, de visibilité en ligne et de processus digitaux pour grandir.",
  "casos_patrona_res": "+75 % d’augmentation du chiffre d’affaires sur l’année écoulée.",
  "casos_patrona_metrica": "CA de l’année écoulée",
  "casos_burek_reto": "Une entreprise de botanique qui voulait se moderniser et passer à un modèle digital automatisé.",
  "casos_burek_res": "Conversion vers un modèle économique avec automatisation digitale complète.",
  "casos_burek_metrica": "Modèle économique",
  "casos_automatizado": "Automatisé",
  "casos_metrica2": "Conversion",
  "casos_ctr": "CTR moyen",
  "casos_leads": "Leads/mois",
  "casos_google": "Google régional",
  "agenda_eyebrow": "Prendre rendez-vous",
  "agenda_title": "Commençons à grandir ensemble",
  "agenda_info_title": "Parlons de votre entreprise",
  "agenda_info_sub": "Une première session sans engagement : nous analysons votre point de départ et vous proposons un plan de croissance sur mesure.",
  "agenda_label_nombre": "Nom complet",
  "agenda_label_email": "Email",
  "agenda_label_telefono": "Téléphone",
  "agenda_label_empresa": "Entreprise",
  "agenda_label_servicio": "Service souhaité",
  "agenda_ph_servicio": "Choisissez un service",
  "agenda_label_fecha": "Date souhaitée",
  "agenda_label_mensaje": "Message",
  "agenda_ph_mensaje": "Décrivez brièvement votre défi ou objectif...",
  "agenda_ph_nombre": "Vos nom et prénom",
  "agenda_ph_empresa": "Votre nom d’entreprise",
  "agenda_btn_solicitar": "Demander un rendez-vous",
  "agenda_btn_enviando": "Envoi...",
  "agenda_error": "Une erreur est survenue. Veuillez réessayer.",
  "agenda_ok_title": "Rendez-vous demandé",
  "agenda_ok_text": "Merci{name}. Nous avons bien enregistré votre demande et vous contacterons sous 24 heures ouvrées pour confirmer la date.",
  "agenda_ok_otra": "Envoyer une autre demande",
  "opt_seo": "SEO - Référencement web",
  "opt_sem": "SEM - Campagnes payantes",
  "opt_branding": "Branding d'entreprise",
  "opt_digital": "Digitalisation d’entreprise",
  "opt_growth": "Growth Partners",
  "map_eyebrow": "Architecture du site",
  "map_title": "Le plan de ce site, prêt pour le SEO",
  "map_intro": "Voici la structure hiérarchique du site, pensée pour optimiser l’exploration et l’indexation. Survolez chaque nœud pour voir son URL et son schéma.",
  "map_ia": "Architecture de l’information",
  "map_note": "Structure évolutive : chaque futur cas de succès vivra sur /casos-de-exito/[client]",
  "map_inicio": "Accueil",
  "map_servicios": "Services",
  "map_casos": "Réussites",
  "map_historia": "Notre histoire",
  "map_agenda": "Prendre rendez-vous",
  "footer_tagline": "Nous grandissons avec vous",
  "footer_volver": "Retour en haut",
  "footer_legal": "Mentions légales - Confidentialité - Cookies",
  "footer_services_line": "SEO - SEM - Branding - Digitalisation",
  "footer_lang": "Langue",
  "wa_general": "Bonjour, je souhaiterais recevoir plus d’informations sur vos services.",
  "wa_branding": "Bonjour, je suis intéressé(e) par vos services de branding et je souhaiterais recevoir plus d’informations.",
  "wa_digitalizacion": "Bonjour, je suis intéressé(e) par la digitalisation de mon entreprise et je souhaiterais recevoir plus d’informations.",
  "wa_automatizacion": "Bonjour, je voudrais savoir quels processus je pourrais automatiser dans mon entreprise.",
  "wa_seosem": "Bonjour, je veux améliorer la visibilité et la captation en ligne de mon entreprise.",
  "wa_growth": "Bonjour, je suis intéressé(e) par votre service Growth Partner et je voudrais savoir comment vous pourriez m’aider à faire grandir mon entreprise.",
  "wa_btn": "Discuter sur WhatsApp",
  "wa_btn_nosotros": "Discutons sur WhatsApp",
  "sp_home_h1": "Des services pour faire grandir votre entreprise",
  "sp_home_intro": "Cinq domaines qui travaillent ensemble — branding, digitalisation, automatisation, SEO & SEM et Growth Partner — pour que votre entreprise attire plus de clients et vende plus.",
  "sp_descubrir": "Découvrir le service",
  "sp_home_cta": "Vous ne savez pas par où commencer ? Racontez-nous votre situation et nous vous orientons.",
  "sp_home_cta_sub": "Nous analysons votre activité et vous recommandons le service avec le plus d’impact dès maintenant.",
  "sp_explora": "Explorez aussi",
  "sp_branding_short": "Une marque qui se reconnaît, se retient et inspire confiance.",
  "sp_digitalizacion_short": "Votre entreprise transformée en une expérience digitale prête à vendre.",
  "sp_automatizacion_short": "Votre entreprise qui travaille même quand vous ne travaillez pas.",
  "sp_seosem_short": "Soyez trouvé quand vos clients vous cherchent.",
  "sp_growth_short": "Nous ne voulons pas être un fournisseur de plus : nous voulons faire grandir votre entreprise comme si c’était la nôtre.",
  "sp_name_branding": "Branding",
  "sp_name_digitalizacion": "Digitalisation",
  "sp_name_automatizacion": "Automatisation",
  "sp_name_seo-sem": "SEO & SEM",
  "sp_name_growth-partner": "Growth Partner",
  "branding_meta_t": "Branding d'entreprise : une marque qu'on retient | #PICHONTEAM",
  "branding_meta_d": "Nous créons une identité visuelle cohérente pour que votre entreprise respire le professionnalisme et la confiance : logo, image de marque, couleurs, typographie, merchandising et image digitale.",
  "branding_h1": "Une marque qui se reconnaît, se retient et inspire confiance.",
  "branding_intro": "Il ne s'agit pas seulement d'avoir un joli logo. Nous créons une identité visuelle cohérente pour que votre entreprise transmette professionnalisme, personnalité et confiance dès le premier regard.",
  "bi1_t": "Conception et maîtrise du logo",
  "bi1_d": "Création d'un nouveau logo ou professionnalisation et perfectionnement du logo existant pour obtenir une image solide, reconnaissable et adaptable à tout format.",
  "bi2_t": "Image de marque",
  "bi2_d": "Définition de l'identité visuelle complète de l'entreprise pour que tous les éléments communiquent la même personnalité.",
  "bi3_t": "Palette de couleurs",
  "bi3_d": "Sélection stratégique des couleurs principales et secondaires qui représentent la personnalité de l’entreprise et maintiennent la cohérence visuelle.",
  "bi4_t": "Typographie",
  "bi4_d": "Sélection et combinaison de typographies professionnelles pour titres, textes, communications et supports digitaux.",
  "bi5_t": "Merchandising",
  "bi5_d": "Adaptation de l’identité visuelle aux vêtements, cartes, packaging, matériels commerciaux, véhicules ou autres supports physiques.",
  "bi6_t": "Image digitale",
  "bi6_d": "Adaptation de la marque au web, aux réseaux sociaux, publicités, profils digitaux, présentations et autres canaux en ligne.",
  "branding_cta": "Vous voulez construire une marque que les gens retiennent ? Contactez-nous pour en savoir plus.",
  "digitalizacion_meta_t": "Digitalisation d’entreprise : des sites qui vendent | #PICHONTEAM",
  "digitalizacion_meta_d": "Landing pages, sites à haute conversion, SEO, catalogues digitaux, réseaux sociaux et e-commerce pour transformer les visiteurs en clients.",
  "digitalizacion_h1": "Nous transformons votre entreprise en une expérience digitale prête à vendre.",
  "digitalizacion_intro": "Être sur Internet ne suffit pas. Votre présence digitale doit inspirer confiance, être facile à utiliser et conçue pour transformer les visiteurs en clients.",
  "di1_t": "Landing Pages",
  "di1_d": "Conception de pages dédiées pour présenter une offre, capturer des contacts ou générer des ventes avec une structure axée sur la conversion.",
  "di2_t": "Sites à haute conversion",
  "di2_d": "Conception et développement de sites modernes, rapides et structurés stratégiquement pour transformer les visites en opportunités commerciales.",
  "di3_t": "Site optimisé pour le SEO",
  "di3_d": "Structures, contenus et éléments techniques préparés pour aider Google à bien comprendre le site et améliorer progressivement son positionnement.",
  "di4_t": "Catalogue digital",
  "di4_d": "Digitalisation des produits et services au moyen de catalogues professionnels, visuels, faciles à consulter et à partager.",
  "di5_t": "Réseaux sociaux",
  "di5_d": "Conception et optimisation de la présence visuelle de l’entreprise sur les réseaux sociaux pour garder une image professionnelle et cohérente.",
  "di6_t": "E-commerce",
  "di6_d": "Création de boutiques en ligne conçues pour fluidifier l’achat et augmenter les conversions.",
  "digitalizacion_cta": "Vous voulez digitaliser votre entreprise et commencer à générer des opportunités en ligne ? Contactez-nous pour en savoir plus.",
  "automatizacion_meta_t": "Automatisation d’entreprise : des processus 24h/24 | #PICHONTEAM",
  "automatizacion_meta_d": "Nous automatisons rendez-vous, calendriers, panneaux d’administration, tableaux de bord, relances et service client pour gagner du temps et servir plus de clients sans surcharge.",
  "automatizacion_h1": "Faites travailler votre entreprise même quand vous ne travaillez pas.",
  "automatizacion_intro": "Nous automatisons les processus répétitifs pour gagner du temps, réduire les erreurs et permettre à votre entreprise de servir plus de clients sans alourdir inutilement la charge de travail.",
  "ai1_t": "Gestion automatisée des rendez-vous",
  "ai1_d": "Des systèmes pour que vos clients puissent consulter les disponibilités et réserver, modifier ou annuler des rendez-vous automatiquement.",
  "ai2_t": "Gestion du calendrier",
  "ai2_d": "Intégration et automatisation des calendriers pour organiser rendez-vous, réunions, disponibilités et rappels.",
  "ai3_t": "Panneaux d’administration",
  "ai3_d": "Création de panneaux personnalisés pour gérer clients, services, rendez-vous, commandes, leads ou autres secteurs clés de l’activité.",
  "ai4_t": "Dashboards",
  "ai4_d": "Des tableaux de bord visuels avec les principales données et métriques de l’entreprise pour comprendre vite ce qui fonctionne et ce qu’il faut améliorer.",
  "ai5_t": "Automatisation d’entreprise",
  "ai5_d": "Connexion et automatisation des tâches répétitives entre les différents outils et processus de l’entreprise.",
  "ai6_t": "Setter automatisé",
  "ai6_d": "Un système pour recevoir, filtrer et qualifier les prospects, poser les premières questions et diriger chaque opportunité vers l’étape commerciale suivante.",
  "ai7_t": "Assistant / répondeur automatique",
  "ai7_d": "Des systèmes de réponse automatique pour le web et les canaux digitaux, capables de répondre aux questions fréquentes, de recueillir des informations et d’aider le client 24h/24.",
  "ai8_t": "Automatisation des relances",
  "ai8_d": "Création de processus automatiques de relance et de rappels pour éviter que des opportunités commerciales se perdent faute de réponse.",
  "automatizacion_cta": "Moins de tâches répétitives. Plus de temps pour faire grandir votre entreprise. Contactez-nous pour en savoir plus.",
  "seosem_meta_t": "SEO & SEM : soyez trouvé quand on vous cherche | #PICHONTEAM",
  "seosem_meta_d": "Nous vous expliquons le SEO et le SEM simplement et vous aidons à apparaître dans les premiers résultats Google avec des stratégies durables et des campagnes efficaces.",
  "seosem_h1": "Soyez trouvé quand vos clients vous cherchent.",
  "seosem_h2_dos": "Deux façons d’apparaître sur Google",
  "seosem_h2_intro": "Être trouvé sur Internet tient, en grande partie, à deux stratégies complémentaires. On vous l’explique sans jargon technique.",
  "seosem_seo_t": "Grandir de façon organique",
  "seosem_seo_p1": "Imaginez que Google est une rue pleine de commerces. Le SEO consiste à amener Google à considérer votre entreprise comme l’une des meilleures adresses qu’il peut recommander lorsqu’on cherche ce que vous vendez.",
  "seosem_seo_p2": "Vous ne payez pas Google pour chaque visite. Nous travaillons votre site, vos contenus, votre structure, votre autorité et d’autres facteurs pour améliorer progressivement votre position dans les résultats de recherche.",
  "seosem_seo_p3": "C’est une stratégie qui demande généralement du temps, mais qui peut générer des résultats durables à moyen et long terme.",
  "seosem_sem_t": "Obtenir de la visibilité grâce à la publicité",
  "seosem_sem_p1": "Le SEM permet de payer pour diffuser des annonces auprès de personnes recherchant des produits ou services spécifiques.",
  "seosem_sem_p2": "Nous utilisons des plateformes publicitaires comme Google Ads et Meta Ads pour amener les prospects vers une offre, une landing page ou un processus de captation.",
  "seosem_sem_p3": "Contrairement au SEO, il permet d’obtenir visibilité et trafic beaucoup plus rapidement, mais nécessite un investissement publicitaire.",
  "seosem_h2_pq": "Pourquoi est-il important d’apparaître en tête de Google ?",
  "seosem_pq_p1": "Quand vous cherchez un restaurant, un avocat, une clinique ou tout autre service, vous faites généralement une recherche Google et commencez par les premiers résultats. Vos clients font exactement la même chose.",
  "seosem_pq_p2": "Être parmi les premières options augmente les chances qu’ils visitent votre site, découvrent votre entreprise et vous contactent plutôt que votre concurrence.",
  "seosem_nota": "La différence principale : en SEO, on ne paie pas directement chaque clic, tandis que les campagnes SEM impliquent un investissement publicitaire. Le travail, la stratégie et les ressources sont présents dans les deux.",
  "seosem_cta": "Vous voulez que vos clients vous trouvent avant votre concurrence ? Contactez-nous pour en savoir plus.",
  "growth_meta_t": "Growth Partner : nous grandissons avec vous | #PICHONTEAM",
  "growth_meta_d": "Nous analysons votre activité, concevons une offre gagnante et construisons un tunnel de conversion complet : stratégie, technologie et automatisation alignées sur votre croissance.",
  "growth_h1": "Nous ne voulons pas être un fournisseur de plus. Nous voulons faire grandir votre entreprise comme si c’était la nôtre.",
  "growth_intro": "Notre service Growth Partner part d’une idée simple : chaque entreprise est différente. Plutôt que de vendre un package fermé de services, nous analysons votre activité, détectons les principales opportunités de croissance et construisons une stratégie adaptée à vos objectifs. Notre croissance est alignée sur celle de nos clients.",
  "growth_modelo": "Notre modèle",
  "g1_t": "Nous analysons votre activité",
  "g1_d": "Nous étudions produit, client, concurrence, positionnement et processus commercial.",
  "g2_t": "Nous concevons une offre gagnante",
  "g2_d": "Nous construisons ou améliorons une offre capable de capter l’attention du client idéal et de lui donner des raisons claires de vous choisir.",
  "g3_t": "Nous créons les éléments à haute conversion",
  "g3_d": "Nous concevons les ressources et créations nécessaires pour présenter cette offre de façon convaincante sur les landing pages, la publicité et les réseaux sociaux.",
  "g4_t": "Nous construisons l’entonnoir",
  "g4_d": "Nous concevons le parcours depuis la découverte de l’entreprise jusqu’à la transformation en opportunité commerciale ou client.",
  "g5_t": "Nous automatisons",
  "g5_d": "Nous automatisons captation, relances, rendez-vous et processus lorsque c’est nécessaire pour réduire la friction et ne perdre aucune opportunité.",
  "g6_t": "Nous mesurons et optimisons",
  "g6_d": "Nous analysons les données pour détecter ce qui fonctionne, améliorer ce qui ne fonctionne pas et augmenter progressivement la conversion.",
  "flow_0": "Trafic",
  "flow_1": "Offre",
  "flow_2": "Landing Page",
  "flow_3": "Lead",
  "flow_4": "Relance",
  "flow_5": "Vente",
  "growth_msj_eyebrow": "Notre façon de travailler",
  "growth_msj_main": "Nous n’appliquons pas la même formule à toutes les entreprises. Nous nous adaptons au client, à son marché, à ses objectifs et à sa situation actuelle.",
  "growth_msj_sub": "Nous agissons comme un partenaire stratégique de croissance : branding, technologie, captation, conversion et automatisation travaillant ensemble avec un unique objectif : faire grandir l’entreprise.",
  "growth_cta_h": "Voulez-vous que nous analysions comment faire grandir votre entreprise ?",
  "growth_cta_sub": "Racontez-nous votre situation et nous étudierons la stratégie la plus adaptée à votre cas.",
  "growth_cta_prefer": "Vous préférez prendre rendez-vous ? ",
  "growth_cta_link": "Prenez rendez-vous ici",
  "sp_meta_t": "Services | #PICHONTEAM Growth Partners",
  "sp_meta_d": "Branding, digitalisation, automatisation, SEO & SEM et Growth Partner : des services pour faire grandir votre entreprise.",
  "llamamos_cerrar": "Fermer",
  "llamamos_btn": "On vous appelle ?",
  "llamamos_title": "On vous appelle",
  "llamamos_sub": "Laissez votre nom et votre téléphone : on vous rappelle sans engagement.",
  "llamamos_nombre": "Nom",
  "llamamos_telefono": "Téléphone",
  "llamamos_ph_nombre": "Votre nom",
  "llamamos_ph_telefono": "Votre numéro de téléphone",
  "llamamos_send": "Oui, appelez-moi",
  "llamamos_enviando": "Envoi...",
  "llamamos_ok_t": "Demande reçue",
  "llamamos_ok_text": "Merci{name}. Nous vous appelons très vite.",
  "llamamos_error": "Impossible d’envoyer. Réessayez."
 },
 "pt": {
  "nav_historia": "A nossa história",
  "nav_mision": "Missão",
  "nav_vision": "Visão",
  "nav_servicios": "Serviços",
  "nav_casos": "Casos de sucesso",
  "nav_arquitectura": "Arquitetura",
  "cta_agendar": "Agendar reunião",
  "hero_eyebrow": "Agência de marketing digital",
  "hero_tagline": "Crescemos consigo",
  "hero_value": "SEO, SEM, posicionamento web, branding corporativo e digitalização de negócios. Transformamos marcas com raízes em árvores que crescem: estratégia orgânica e dados precisos para escalar a sua empresa.",
  "cta_agenda": "Agendar reunião",
  "cta_servicios": "Descobrir os serviços",
  "metric_roi": "ROI médio",
  "metric_retencion": "Retenção de clientes",
  "metric_proyectos": "Projetos liderados",
  "hero_badge_t": "Crescemos consigo",
  "mq_0": "#PICHONTEAM",
  "mq_1": "GROWTH PARTNERS",
  "mq_2": "CRECEMOS CONSIGO",
  "mq_3": "SEO & SEM",
  "mq_4": "BRANDING CORPORATIVO",
  "mq_5": "DIGITALIZAÇÃO DE NEGÓCIOS",
  "mq_6": "POSICIONAMENTO WEB",
  "story_eyebrow": "A nossa história",
  "story_title": "Dois caminhos, um fio vermelho",
  "scene_word": "Cena",
  "story1_label": "A origem",
  "story1_title": "Dois mundos paralelos",
  "story1_text": "Ano 2022. Duas vidas a percorrer caminhos completamente separados. Ele, mergulhado no vibrante mundo da hostalaria, do turismo e das operações em pleno auge mediterrânico. Ela, a percorrer um caminho tradicional e metódico entre números, empresa e logística, à procura de algo que a realizasse verdadeiramente. Aparentemente distantes, mas ambos partilhavam uma centelha secreta: a criatividade.",
  "story2_label": "O ponto de encontro",
  "story2_title": "O fio vermelho",
  "story2_text": "Ano 2023. O destino cruza os nossos caminhos e começamos a tramar um fio vermelho. Sem o sabermos ao início, esse fio iria costurando uma rede invisível, o alicerce silencioso sobre o qual construiríamos um novo projeto de vida.",
  "story3_label": "A evolução e a aprendizagem",
  "story3_title": "Convergência",
  "story3_text": "Entre 2023 e 2024, os projetos pessoais e profissionais evoluíram para uma profunda convergência. Alimentando-nos das nossas próprias experiências e das do outro, começámos a dar forma a novas marcas e a projetos conjuntos, aprendendo a complementar-nos na perfeição.",
  "story4_label": "O grande desafio",
  "story4_title": "O salto mortal duplo",
  "story4_text": "Ano 2025. Enfrentámos a missão mais difícil: uma reconversão profissional radical. O desafio de nos reinventar e, além disso, nos tornarmos sócios de um novo projeto partilhado, somando o desafio da vida em casal e do casamento. Não foi fácil, mas fortaleceu-nos.",
  "story5_label": "O presente e o futuro",
  "story5_title": "Comunidade e liderazgo",
  "story5_text": "Hoje, em 2026, cheios de ilusão e esperança, e finalmente mais unidos do que nunca, lideramos uma grande equipa de empresas, agentes e parceiros. Juntos impulsionamos uma rede de colaboração mútua, caminhando firmes rumo a um crescimento que é, ao mesmo tempo, orgânico, digital e sustentável.",
  "mv_eyebrow": "O nosso norte",
  "mv_title": "Missão e Visão",
  "mv_mision_t": "Missão",
  "mv_mision_main": "Transformamos negócios tradicionais e digitais em marcas líderes através de estratégias sustentáveis, mensuráveis e humanas.",
  "mv_mision_sub": "Trabalhamos lado a lado com cada cliente: SEO, SEM, branding e digitalização ao serviço de objetivos de negócio reais, não de vaidades.",
  "mv_vision_t": "Visão",
  "mv_vision_main": "Crescimento compartilhado: desenhamos o caminho para que ambos alcancemos a nossa melhor versão",
  "mv_vision_sub": "Temos como objetivo ser o parceiro estratégico de crescimento mais confiável do mercado hispanofalante.",
  "sv_eyebrow": "Serviços",
  "sv_title": "Quatro pilares, um só objetivo: crescer",
  "sv_intro": "Posicionamento web, campanhas pagas, marca e tecnologia. Escolha um pilar ou combine os quatro como Growth Partners.",
  "sv_ver_todos": "Ver todos os serviços",
  "caso_eyebrow": "Caso de sucesso",
  "caso_estrategia": "A estratégia",
  "caso_desafio": "O desafio",
  "caso_back": "Todos os casos",
  "caso_ver": "Ver caso completo",
  "caso_antes": "Logótipo original",
  "caso_despues": "Nova proposta de marca",
  "caso_paleta": "Paleta de cores desenhada",
  "caso_tipografia": "Tipografias da marca",
  "caso_valor": "Proposta de valor de marca",
  "caso_resultado": "Resultado",
  "caso_proceso": "Como trabalhámos a mudança de marca",
  "caso_pendiente": "Conteúdo de marca em preparação: publicá-lo-emos aqui assim que estiver pronto.",
  "caso_otro": "Caso seguinte",
  "caso_cta": "Queres resultados assim? Falemos.",
  "sv_ver": "Ver serviço",
  "pillar1_t": "Digitalização de negócios",
  "pillar1_d": "Levamos a vossa operação para o mundo digital: automatizações, CRM e infraestrutura digital para trabalhar melhor e vender mais.",
  "pillar1_tag": "Impacto: eficiência +40%",
  "pillar1_i1": "Automatização de processos",
  "pillar1_i2": "Implantação de CRM",
  "pillar1_i3": "Infraestrutura digital",
  "pillar1_i4": "Eficiência operativa",
  "pillar2_t": "Branding corporativo",
  "pillar2_d": "Marcas com alma e sistema: da arquitetura de marca ao manual de estilo, tudo pensado para posicionar.",
  "pillar2_tag": "Impacto: notoriedade da marca",
  "pillar2_i1": "Arquitetura de marca",
  "pillar2_i2": "Identidade visual",
  "pillar2_i3": "Posicionamento de marca",
  "pillar2_i4": "Manual de estilo",
  "pillar3_t": "SEO e SEM",
  "pillar3_d": "Posicionamento orgânico e campanhas pagas medidas em vendas, não em impressões.",
  "pillar3_tag": "Impacto: ROI publicitário",
  "pillar3_i1": "SEO orgânico e técnico",
  "pillar3_i2": "Google Ads e Meta PPC",
  "pillar3_i3": "Analítica web avançada",
  "pillar3_i4": "CRO e testes contínuos",
  "pillar4_t": "Growth Partners",
  "pillar4_d": "O nosso modelo de acompanhamento 360: estratégia, execução e dados ao vosso lado em cada decisão de crescimento.",
  "pillar4_tag": "Impacto: crescimento sustentado",
  "pillar4_i1": "Acompanhamento 360",
  "pillar4_i2": "Escalabilidade de receitas",
  "pillar4_i3": "Estratégia de receitas recorrentes",
  "pillar4_i4": "Comité mensual de growth",
  "casos_eyebrow": "Casos de sucesso",
  "casos_title": "Histórias reais, resultados mensuráveis",
  "casos_intro": "Projetos reais construídos com os nossos clientes: marcas que hoje crescem connosco.",
  "casos_reto": "O desafio: ",
  "casos_resultado": "O resultado: ",
  "casos_gato_reto": "Um negócio de hostalaria com carácter próprio que precisava de uma marca forte e de processos digitais para dar o salto.",
  "casos_gato_res": "+180% de aumento na faturação global do negócio.",
  "casos_gato_metrica": "Faturação global",
  "casos_patrona_reto": "Uma empresa de eventos que precisava de uma marca sólida, visibilidade online e processos digitais para crescer.",
  "casos_patrona_res": "+75% de aumento na faturação no último ano.",
  "casos_patrona_metrica": "Faturação no último ano",
  "casos_burek_reto": "Um negócio de botânica que queria modernizar-se e passar para um modelo digital automatizado.",
  "casos_burek_res": "Conversão para um modelo de negócio com automação digital completa.",
  "casos_burek_metrica": "Modelo de negócio",
  "casos_automatizado": "Automatizado",
  "casos_metrica2": "Conversão",
  "casos_ctr": "CTR médio",
  "casos_leads": "Leads/mês",
  "casos_google": "Google regional",
  "agenda_eyebrow": "Agendar reunião",
  "agenda_title": "Comecemos a crescer consigo",
  "agenda_info_title": "Falemos do vosso negócio",
  "agenda_info_sub": "Uma primeira sessão sem compromisso: analisamos o vosso ponto de partida e propomos um plano de crescimento à medida.",
  "agenda_label_nombre": "Nome completo",
  "agenda_label_email": "Email",
  "agenda_label_telefono": "Telefone",
  "agenda_label_empresa": "Empresa",
  "agenda_label_servicio": "Serviço de interesse",
  "agenda_ph_servicio": "Escolha um serviço",
  "agenda_label_fecha": "Data preferida",
  "agenda_label_mensaje": "Mensagem",
  "agenda_ph_mensaje": "Conte-nos brevemente o vosso desafio ou objetivo...",
  "agenda_ph_nombre": "O vosso nome completo",
  "agenda_ph_empresa": "O nome da vossa empresa",
  "agenda_btn_solicitar": "Solicitar reunião",
  "agenda_btn_enviando": "A enviar...",
  "agenda_error": "Ocorreu um problema. Tente novamente.",
  "agenda_ok_title": "Reunião solicitada",
  "agenda_ok_text": "Obrigado{name}. Registámos o vosso pedido e entraremos em contacto em menos de 24 horas úteis para confirmar a data.",
  "agenda_ok_otra": "Enviar outro pedido",
  "opt_seo": "SEO - Posicionamento web",
  "opt_sem": "SEM - Campanhas pagas",
  "opt_branding": "Branding corporativo",
  "opt_digital": "Digitalização de negócios",
  "opt_growth": "Growth Partners",
  "map_eyebrow": "Arquitetura web",
  "map_title": "O mapa deste site, pronto para SEO",
  "map_intro": "Esta é a estrutura hierárquica do site, pensada para otimizar a indexação pelos motores de busca. Passe o cursor por cada nó para ver o seu URL e esquema.",
  "map_ia": "Arquitetura da informação",
  "map_note": "Estrutura escalável: cada futuro caso de sucesso viverá em /casos-de-exito/[cliente]",
  "map_inicio": "Início",
  "map_servicios": "Serviços",
  "map_casos": "Casos de sucesso",
  "map_historia": "A nossa história",
  "map_agenda": "Agendar reunião",
  "footer_tagline": "Crescemos consigo",
  "footer_volver": "Voltar ao topo",
  "footer_legal": "Aviso legal - Privacidade - Cookies",
  "footer_services_line": "SEO - SEM - Branding - Digitalização",
  "footer_lang": "Idioma",
  "wa_general": "Olá, gostaria de receber mais informação sobre os vossos serviços.",
  "wa_branding": "Olá, estou interessado/a nos serviços de Branding e gostaria de receber mais informação.",
  "wa_digitalizacion": "Olá, estou interessado/a em digitalizar o meu negócio e gostaria de receber mais informação.",
  "wa_automatizacion": "Olá, quero saber que processos poderia automatizar no meu negócio.",
  "wa_seosem": "Olá, quero melhorar a visibilidade e a captação online do meu negócio.",
  "wa_growth": "Olá, estou interessado/a no serviço Growth Partner e gostaria de saber como nos poderiam ajudar a fazer crescer o meu negócio.",
  "wa_btn": "Falar por WhatsApp",
  "wa_btn_nosotros": "Fale connosco por WhatsApp",
  "sp_home_h1": "Serviços para fazer crescer o vosso negócio",
  "sp_home_intro": "Cinco áreas que trabalham em conjunto —branding, digitalização, automatização, SEO & SEM e Growth Partner— para que o vosso negócio atraia mais clientes e venda mais.",
  "sp_descubrir": "Descobrir o serviço",
  "sp_home_cta": "Não sabe por onde começar? Conte-nos a vossa situação e orientamos.",
  "sp_home_cta_sub": "Analisamos o vosso negócio e recomendamos o serviço com maior impacto neste momento.",
  "sp_explora": "Explore também",
  "sp_branding_short": "Uma marca que se reconhece, se lembra e transmite confiança.",
  "sp_digitalizacion_short": "O vosso negócio convertido numa experiência digital pronta para vender.",
  "sp_automatizacion_short": "O vosso negócio a trabalhar mesmo quando não está a trabalhar.",
  "sp_seosem_short": "Sejam encontrados quando os vossos clientes vos procuram.",
  "sp_growth_short": "Não queremos ser mais um fornecedor: queremos fazer crescer o vosso negócio como se fosse nosso.",
  "sp_name_branding": "Branding",
  "sp_name_digitalizacion": "Digitalização",
  "sp_name_automatizacion": "Automação",
  "sp_name_seo-sem": "SEO e SEM",
  "sp_name_growth-partner": "Growth Partner",
  "branding_meta_t": "Branding corporativo: uma marca que se lembra | #PICHONTEAM",
  "branding_meta_d": "Criamos uma identidade visual coerente para que o vosso negócio transmita profissionalidade e confiança: logótipo, imagem de marca, cor, tipografia, merchandising e imagem digital.",
  "branding_h1": "Uma marca que se reconhece, se lembra e transmite confiança.",
  "branding_intro": "Não se trata apenas de ter um logótipo bonito. Criamos uma identidade visual coerente para que o vosso negócio transmita profissionalidade, personalidade e confiança desde o primeiro olhar.",
  "bi1_t": "Desenho e masterização de logótipo",
  "bi1_d": "Criação de um novo logótipo ou profissionalização e aperfeiçoamento do logótipo existente, para conseguir uma imagem sólida, reconhecível e adaptável a qualquer formato.",
  "bi2_t": "Imagem de marca",
  "bi2_d": "Definição da identidade visual completa do negócio, para que todos os elementos comuniquem a mesma personalidade.",
  "bi3_t": "Paleta de cores",
  "bi3_d": "Seleção estratégica de cores principais e secundárias que representem a personalidade da empresa e mantenham a coerência visual.",
  "bi4_t": "Tipografia",
  "bi4_d": "Seleção e combinação de tipografias profissionais para títulos, textos, comunicações e suportes digitais.",
  "bi5_t": "Merchandising",
  "bi5_d": "Adaptação da identidade visual a roupa, cartões, packaging, material comercial, viaturas ou outros suportes físicos.",
  "bi6_t": "Imagem digital",
  "bi6_d": "Adaptação da marca a site, redes sociais, anúncios, perfis digitais, apresentações e outros canais online.",
  "branding_cta": "Querem construir uma marca de que as pessoas se lembram? Contactem-nos para mais informação.",
  "digitalizacion_meta_t": "Digitalização de negócios: sites que vendem | #PICHONTEAM",
  "digitalizacion_meta_d": "Landing pages, sites de alta conversão, SEO, catálogos digitais, redes sociais e e-commerce para transformar visitantes em clientes.",
  "digitalizacion_h1": "Transformamos o vosso negócio numa experiência digital pronta para vender.",
  "digitalizacion_intro": "Não basta estar na Internet. A vossa presença digital deve transmitir confiança, ser fácil de utilizar e estar desenhada para transformar visitantes em clientes.",
  "di1_t": "Landing Pages",
  "di1_d": "Desenho de páginas específicas para apresentar uma oferta, captar contactos ou conseguir vendas com uma estrutura focada na conversão.",
  "di2_t": "Sites de alta conversão",
  "di2_d": "Desenho e desenvolvimento de sites modernos, rápidos e estruturados estrategicamente para converter visitas em oportunidades comerciais.",
  "di3_t": "Site otimizado para SEO",
  "di3_d": "Estruturas, conteúdos e elementos técnicos preparados para ajudar o Google a perceber corretamente o site e melhorar progressivamente o seu posicionamento.",
  "di4_t": "Catálogo digital",
  "di4_d": "Digitalização de produtos e serviços através de catálogos profissionais, visuais, fáceis de consultar e partilhar.",
  "di5_t": "Redes sociais",
  "di5_d": "Desenho e otimização da presença visual do negócio nas redes sociais, para manter uma imagem profissional e coerente.",
  "di6_t": "E-commerce",
  "di6_d": "Criação de lojas online desenhadas para facilitar o processo de compra e aumentar as conversões.",
  "digitalizacion_cta": "Querem digitalizar o vosso negócio e começar a gerar oportunidades online? Contactem-nos para mais informação.",
  "automatizacion_meta_t": "Automação de negócios: processos 24/7 | #PICHONTEAM",
  "automatizacion_meta_d": "Automatizamos reuniões, calendários, painéis, dashboards, seguimentos e atendimento ao cliente para poupar tempo e atender mais clientes sem mais carga de trabalho.",
  "automatizacion_h1": "Façam o vosso negócio trabalhar mesmo quando não estão a trabalhar.",
  "automatizacion_intro": "Automatizamos processos repetitivos para poupar tempo, reduzir erros e permitir que a vossa empresa atenda mais clientes sem aumentar desnecessariamente a carga de trabalho.",
  "ai1_t": "Gestão automática de marcações",
  "ai1_d": "Sistemas para que os clientes possam consultar a disponibilidade e marcar, alterar ou cancelar marcações automaticamente.",
  "ai2_t": "Gestão de calendário",
  "ai2_d": "Integração e automatização de calendários para organizar marcações, reuniões, disponibilidade e lembretes.",
  "ai3_t": "Painéis de administração",
  "ai3_d": "Criação de painéis personalizados a partir dos quais gerir clientes, serviços, marcações, encomendas, leads ou outras áreas importantes do negócio.",
  "ai4_t": "Dashboards",
  "ai4_d": "Painéis visuais com os principais dados e métricas do negócio, para perceber rapidamente o que está a funcionar e o que precisa de melhorar.",
  "ai5_t": "Automação de negócio",
  "ai5_d": "Ligação e automatização de tarefas repetitivas entre as diferentes ferramentas e processos da empresa.",
  "ai6_t": "Setter automático",
  "ai6_d": "Sistema para receber, filtrar e qualificar potenciais clientes, fazer perguntas iniciais e encaminhar cada oportunidade para o passo comercial seguinte.",
  "ai7_t": "Assistente / resposta automática",
  "ai7_d": "Sistemas automáticos de resposta para site e canais digitais, capazes de responder a perguntas frequentes, recolher informação e ajudar o cliente 24/7.",
  "ai8_t": "Automatização de seguimento",
  "ai8_d": "Criação de processos automáticos de seguimento, envio de lembretes e prevenção de perda de oportunidades comerciais por falta de resposta.",
  "automatizacion_cta": "Menos tarefas repetitivas. Mais tempo para fazer crescer o vosso negócio. Contactem-nos para mais informação.",
  "seosem_meta_t": "SEO e SEM: sejam encontrados quando vos procuram | #PICHONTEAM",
  "seosem_meta_d": "Explicamos o SEO e o SEM de forma simples e ajudamos a aparecer nos primeiros resultados do Google com estratégias sustentáveis e campanhas eficazes.",
  "seosem_h1": "Sejam encontrados quando os vossos clientes vos procuram.",
  "seosem_h2_dos": "Duas formas de aparecer no Google",
  "seosem_h2_intro": "Ser encontrado na Internet reduz-se, em grande parte, a duas estratégias complementares. Explicamos sem palavras técnicas.",
  "seosem_seo_t": "Crescer de forma orgânica",
  "seosem_seo_p1": "Imaginem que o Google é uma rua cheia de negócios. O SEO consiste em fazer com que o Google considere o vosso negócio um dos melhores sítios que pode recomendar quando alguém procura o que vendem.",
  "seosem_seo_p2": "Não pagam ao Google por cada visita. Trabalhamos o vosso site, conteúdos, estrutura, autoridade e outros fatores para melhorar progressivamente a vossa posição nos resultados de pesquisa.",
  "seosem_seo_p3": "É uma estratégia que normalmente precisa de tempo, mas pode gerar resultados sustentáveis a médio e longo prazo.",
  "seosem_sem_t": "Obter visibilidade através de publicidade",
  "seosem_sem_p1": "O SEM permite pagar para mostrar anúncios a pessoas que estão à procura de determinados produtos ou serviços.",
  "seosem_sem_p2": "Utilizamos plataformas publicitárias como o Google Ads e o Meta Ads para levar potenciais clientes até uma oferta, landing page ou processo de captação.",
  "seosem_sem_p3": "Ao contrário do SEO, permite obter visibilidade e tráfego muito mais depressa, mas requer investimento publicitário.",
  "seosem_h2_pq": "Porque é que importa aparecer nos primeiros lugares do Google?",
  "seosem_pq_p1": "Quando precisam de um restaurante, um advogado, uma clínica ou qualquer outro serviço, normalmente procuram no Google e começam pelos primeiros resultados. Os vossos clientes fazem exatamente o mesmo.",
  "seosem_pq_p2": "Estar entre as primeiras opções aumenta a probabilidade de entrarem no vosso site, conhecerem o vosso negócio e acabarem por vos contactar em vez de contactarem a vossa concorrência.",
  "seosem_nota": "A diferença principal: em SEO não se paga diretamente por cada clique, enquanto nas campanhas SEM existe investimento publicitário. O trabalho, a estratégia e os recursos estão presentes em ambos.",
  "seosem_cta": "Querem que os vossos clientes vos encontrem antes da vossa concorrência? Contactem-nos para mais informação.",
  "growth_meta_t": "Growth Partner: crescemos consigo | #PICHONTEAM",
  "growth_meta_d": "Analisamos o vosso negócio, desenhamos uma oferta vencedora e construímos um funil de conversão completo: estratégia, tecnologia e automatização alinhadas com o vosso crescimento.",
  "growth_h1": "Não queremos ser mais um fornecedor. Queremos fazer crescer o vosso negócio como se fosse nosso.",
  "growth_intro": "O nosso serviço de Growth Partner parte de uma ideia simples: cada empresa é diferente. Em vez de vender um pacote fechado de serviços, analisamos o vosso negócio, detetamos onde estão as principais oportunidades de crescimento e construímos uma estratégia adaptada aos vossos objetivos. O nosso crescimento está alinhado com o crescimento dos nossos clientes.",
  "growth_modelo": "O nosso modelo",
  "g1_t": "Analisamos o vosso negócio",
  "g1_d": "Estudamos produto, cliente, concorrência, posicionamento e processo comercial.",
  "g2_t": "Desenhamos uma oferta vencedora",
  "g2_d": "Construímos ou melhoramos uma oferta capaz de captar a atenção do cliente ideal e de lhe dar razões claras para vos escolher.",
  "g3_t": "Criamos os elementos de alta conversão",
  "g3_d": "Desenhamos os recursos e criatividades necessários para apresentar essa oferta de forma convincente em landing pages, publicidade e redes sociais.",
  "g4_t": "Construímos o funil",
  "g4_d": "Desenhamos o percurso desde que uma pessoa descobre o negócio até se tornar numa oportunidade comercial ou cliente.",
  "g5_t": "Automatizamos",
  "g5_d": "Automatizamos captação, seguimento, marcações e processos quando é necessário, para reduzir a fricção e evitar perder oportunidades.",
  "g6_t": "Medimos e otimizamos",
  "g6_d": "Analisamos os dados para detetar o que funciona, melhorar o que não funciona e aumentar progressivamente a conversão.",
  "flow_0": "Tráfego",
  "flow_1": "Oferta",
  "flow_2": "Landing Page",
  "flow_3": "Lead",
  "flow_4": "Seguimento",
  "flow_5": "Venda",
  "growth_msj_eyebrow": "A nossa forma de trabalhar",
  "growth_msj_main": "Não aplicamos a mesma fórmula a todos os negócios. Adaptamo-nos ao cliente, ao seu mercado, aos seus objetivos e à sua situação atual.",
  "growth_msj_sub": "Atuamos como um parceiro estratégico de crescimento: branding, tecnologia, captação, conversão e automatização a trabalhar em conjunto com um único objetivo: fazer crescer o negócio.",
  "growth_cta_h": "Querem que analisemos como podemos fazer crescer o vosso negócio?",
  "growth_cta_sub": "Contem-nos a vossa situação e estudaremos que estratégia faz mais sentido para vós.",
  "growth_cta_prefer": "Prefere agendar uma reunião? ",
  "growth_cta_link": "Agende a vossa reunião aqui",
  "sp_meta_t": "Serviços | #PICHONTEAM Growth Partners",
  "sp_meta_d": "Branding, digitalização, automatização, SEO e SEM e Growth Partner: serviços para fazer crescer o vosso negócio.",
  "llamamos_cerrar": "Fechar",
  "llamamos_btn": "Ligamos-vos?",
  "llamamos_title": "Ligamos-vos",
  "llamamos_sub": "Deixem o vosso nome e telefone e ligamos sem compromisso.",
  "llamamos_nombre": "Nome",
  "llamamos_telefono": "Telefone",
  "llamamos_ph_nombre": "O vosso nome",
  "llamamos_ph_telefono": "O vosso número de telefone",
  "llamamos_send": "Sim, liguem-me",
  "llamamos_enviando": "A enviar...",
  "llamamos_ok_t": "Pedido recebido",
  "llamamos_ok_text": "Obrigado{name}. Ligamos muito em breve.",
  "llamamos_error": "Não foi possível enviar. Tente novamente."
 }
};

const LangContext = createContext({ lang: 'es', setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            const saved = localStorage.getItem('pichonteam_lang');
            return LANGS.some((l) => l.code === saved) ? saved : 'es';
        } catch (e) {
            return 'es';
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem('pichonteam_lang', lang);
        } catch (e) {}
        document.documentElement.lang = lang;
    }, [lang]);

    const t = (key) => DICT[lang]?.[key] ?? DICT.es[key] ?? key;

    return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
